module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/cremona.52519d35a3e22a7028949ce2742125b0.jpg";